"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRAME_RATE = exports.VIDEO_HEIGHT = exports.VIDEO_WIDTH = void 0;
exports.VIDEO_WIDTH = 1280;
exports.VIDEO_HEIGHT = 720;
exports.FRAME_RATE = 30;
//# sourceMappingURL=constants.js.map